import { makeStyles } from '@material-ui/core/styles';

export function useColorPickerInputStyles() {
    const useStyles = makeStyles((theme) => ({
        input: {
            position: "absolute",
            top: 40,
            width: 0,
            height: 0,
            opacity: 0,
            textTransform: "uppercase",
        },
        colorBox: {
            display: "inline-block",
            width: 32,
            height: 32,
            borderRadius: "50%",
            border: "1px solid #000",
            cursor: "pointer",
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
